export enum SystemInfoOsNameEnum {
    WINDOWS = 'Windows',
    IOS = 'iOS',
    MACOS = 'macOS',
    ANDROID = 'Android',
}
